import Vue from 'vue'
import { Module, GetterTree, MutationTree, ActionTree } from 'vuex'
import axios from 'axios'
import { API_URL } from '@/config'

const SET_TOKEN = 'SET_TOKEN'

interface State {
  token?: string,
}

const state: State = {
  token: undefined
}

const getters = {
}

const actions: ActionTree<State, any> = {
  login: ({ commit }, password: string) => {
    return axios.post(`${API_URL}/session`, {
      password,
    }).then(response => {
      const token = response.data.private
      commit(SET_TOKEN, token)
      localStorage.setItem('token', token)
    })
  },
  isLoggedIn: ({ state, commit }) => {
    if (!state.token) {
      const token = localStorage.getItem('token')
      if (token) {
        commit(SET_TOKEN, token)
      } else {
        return Promise.resolve(false)
      }
    }

    return axios.get(`${API_URL}/session/${state.token}`).then(response => {
      return Promise.resolve(true)
    })
    .catch(error => {
      if (error.response && error.response.status < 500) {
        return Promise.resolve(false)
      } else {
        return Promise.reject(error)
      }
    })
  },
}

const mutations: MutationTree<State> = {
  [SET_TOKEN] (state, token) {
    state.token = token
  }
}

const mod: Module<State, any> = {
  state,
  getters,
  actions,
  mutations,
}

export default mod
